import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkforceLayoutService {
  private isSmallScreenSubject = new BehaviorSubject<boolean>(false);
  isSmallScreen$ = this.isSmallScreenSubject.asObservable();

  // Emits when something (e.g. the sidebar nav) requests the chat history drawer to open.
  private openChatHistorySubject = new Subject<void>();
  openChatHistory$ = this.openChatHistorySubject.asObservable();
  // Set when the request is made while navigating to the chat page, so the chat
  // component can open the drawer on init (it isn't subscribed yet to catch the emit).
  private pendingOpenChatHistory = false;

  requestOpenChatHistory(): void {
    this.openChatHistorySubject.next();
  }

  setPendingOpenChatHistory(): void {
    this.pendingOpenChatHistory = true;
  }

  consumePendingOpenChatHistory(): boolean {
    const pending = this.pendingOpenChatHistory;
    this.pendingOpenChatHistory = false;
    return pending;
  }

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([
        Breakpoints.HandsetPortrait,
        Breakpoints.TabletPortrait,
        Breakpoints.HandsetLandscape,
      ])
      .subscribe((result) => {
        this.isSmallScreenSubject.next(result.matches);
      });
  }

  get isSmallScreen(): boolean {
    return this.isSmallScreenSubject.value;
  }
}
